export enum SentryTransaction {
  ApiSearch = 'api-search',
}
